import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import serverList from "../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { banRoleChatList, unbanRoleChat } from "@/api/role";
import { getGameServerMap, getUserInfoMap } from "@/utils/dictionary";
import BanSomeChat from "./components/banSomeChat.vue";
import BanRoleChat from "./components/banRoleChat.vue";
export default {
  components: {
    serverList: serverList,
    BanSomeChat: BanSomeChat,
    BanRoleChat: BanRoleChat
  },
  name: "userBanned",
  mixins: [infoList],
  data: function data() {
    return {
      centerDialogVisible: false,
      banRoleDialog: false,
      listApi: banRoleChatList,
      serverId: "",
      searchInfo: {},
      serverList: {},
      userList: {},
      banForm: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getGameServerMap();
          case 2:
            _this.serverList = _context.sent;
            _context.next = 5;
            return getUserInfoMap();
          case 5:
            _this.userList = _context.sent;
            _this.getTableData();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    backPerson: function backPerson(res) {
      this.centerDialogVisible = res.isback;
      this.getTableData();
    },
    queryEvent: function queryEvent() {
      this.getTableData();
      if (this.tableData.length === 0) {
        this.$message({
          message: "暂无数据"
        });
      }
    },
    unBanRole: function unBanRole(server_id, role_id) {
      var _this2 = this;
      var unbanRoleData = {
        server_id: server_id,
        role_list: [role_id]
      };
      unbanRoleChat(unbanRoleData).then(function (res) {
        if (res.code == 0) {
          _this2.$message({
            type: "success",
            message: "解封成功"
          });
          _this2.getTableData();
        }
      });
    },
    banRole: function banRole(server_id, role_id) {
      this.banForm.serverId = server_id;
      this.banForm.roleId = role_id;
      this.banRoleDialog = true;
    },
    banFinish: function banFinish() {
      this.banRoleDialog = false;
      this.getTableData();
    }
  }
};